import { useSelector } from 'react-redux';
import React from 'react';

import InvoicingData from './invoicingData';
import ContainerSectionMobile from '../../components/containerSectionMobile';
import ContainerSectionDesktop from '../../components/containerSectionDesktop';

import './invoicingDataScreen.scss';

const InvoicingDataScreen = () => {
  const isMobileDevice = useSelector((state) => state.mediaQuery.isMobileDevice);

  return (
    isMobileDevice ? (
      <ContainerSectionMobile className="profile-information">
        <InvoicingData />
      </ContainerSectionMobile>
    ) : (
      <ContainerSectionDesktop>
        <InvoicingData />
      </ContainerSectionDesktop>
    )
  );
};

export default InvoicingDataScreen;
